import type { Rarity, Stone } from './types';
import { stones } from '../data/stones';

/** ガチャ排出テーブル(重み)。
 *  低ティア70%, 中ティア20%, レア10% の確率。 */
export const GACHA_WEIGHTS: Record<Rarity, number> = {
  low: 70,
  mid: 20,
  high: 10,
};

/** ガチャ排出: 重み付き抽選で1種を返す。 */
export function rollGacha(): Stone {
  const total = Object.values(GACHA_WEIGHTS).reduce((a, b) => a + b, 0);
  let r = Math.random() * total;

  let chosenRarity: Rarity = 'low';
  for (const [rarity, weight] of Object.entries(GACHA_WEIGHTS) as [Rarity, number][]) {
    r -= weight;
    if (r <= 0) {
      chosenRarity = rarity;
      break;
    }
  }

  const candidates = stones.filter((s) => s.rarity === chosenRarity);
  if (candidates.length === 0) {
    // フォールバック: 全体からランダム
    return stones[Math.floor(Math.random() * stones.length)]!;
  }
  return candidates[Math.floor(Math.random() * candidates.length)]!;
}
